import Vue from 'vue'
import VueRouter from 'vue-router'
import VueWechatTitle from 'vue-wechat-title';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'

import PocketIndex from 'page/pocket/index'
import PocketDetail from 'page/pocket/detail'
import TradeDetail from 'page/trade/detail'
import TradePlaneTrade from 'page/trade/planeTrade'
import ProtocolRecharge from 'page/protocol/recharge'
import ProtocolPlaneRecharge from 'page/protocol/planeRecharge'

import DDBProtocolRecharge from 'page/ddbProtocol/ddbProtocol'
import DDBProtocolAndroidRecharge from 'page/ddbProtocol/ddbProtocolAndroid'
import Login from 'page/scene/login/login'

import sceneCreate from 'page/scene/create/create'
import Manage from 'page/scene/manage/manage'
import Business from 'page/scene/business/business'
import ShopSearch from 'page/scene/shopSearch/shopSearch'
import SearchList from 'page/scene/searchList/searchList'
import { transObj } from '@/utils/translate';

Vue.use(VueRouter)
Vue.use(Mint);
Vue.use(VueWechatTitle)



const Routes = [
  {
    path: '/webpay/pocket/list',
    name: 'PocketIndex',
    component: PocketIndex,
  },
  {
    path: '/webpay/pocket/detail',
    name: 'PocketDetail',
    component: PocketDetail,
  },
  {
    path: '/webpay/trade/detail',
    name: 'TradeDetail',
    component: TradeDetail,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/webpay/trade/planeTrade',
    name: 'TradePlaneTrade',
    component: TradePlaneTrade,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/webpay/protocol/recharge',
    name: 'ProtocolRecharge',
    component: ProtocolRecharge,
    meta: {
      // title: '铛铛充值协议' || zh.webpay.protocol.recharge.title
      title: transObj.$t('铛铛充值协议')
    }
  },
  {
    path: '/webpay/protocol/planeRecharge',
    name: 'ProtocolPlaneRecharge',
    component: ProtocolPlaneRecharge,
    meta: {
      title: '铛铛充值协议'
    }
  },
  {
    path: '/webpay/ddbProtocol/recharge',
    name: 'DDBProtocolRecharge',
    component: DDBProtocolRecharge,
    meta: {
      title: '充值服务协议'
    }
  },
  {
    path: '/webpay/ddbProtocolAndroid/recharge',
    name: 'DDBProtocolAndroidRecharge',
    component: DDBProtocolAndroidRecharge,
    meta: {
      title: '充值服务协议'
    }
  },
  {
    path: '/webpay/scene/create',
    name: 'sceneCreate',
    component: sceneCreate,
    meta: {
      title: '创建现场'
    }
  },
  {
    path: '/webpay/scene/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/webpay/scene/manage',
    name: 'Manage',
    component: Manage,
    meta: {
      title: '铛铛运营录入系统'
    }
  },
  {
    path: '/webpay/scene/business',
    name: 'Business',
    component: Business,
    meta: {
      title: '添加商家运营'
    }
  },
  {
    path: '/webpay/scene/shopSearch',
    name: 'ShopSearch',
    component: ShopSearch,
    meta: {
      title: '商家搜索'
    }
  },
  {
    path: '/webpay/scene/SearchList',
    name: 'SearchList',
    component: SearchList,
    meta: {
      title: '所有商家列表'
    }
  }
]

export default new VueRouter({
  mode: 'history',
  routes: Routes
})



// WEBPACK FOOTER //
// ./src/router/index.js